import {Illustration} from '../illustrations/illustration';

import type {ChecklistItem, ChecklistKey} from './types';

export const getIllustration = (key: ChecklistKey) => {
    switch (key) {
        case 'createBroadcast':
            return <Illustration src='trial-onboarding/marketing-email-campaigns' />;
        case 'createForm':
            return <Illustration src='trial-onboarding/marketing-forms' />;
        case 'useAnalytics':
            return <Illustration src='trial-onboarding/marketing-analytics' />;
        case 'connectExternalAccount':
            return <Illustration src='trial-onboarding/sales-connect-external-account' />;
        case 'importContacts':
            return <Illustration src='trial-onboarding/sales-import-data' />;
        case 'embedChat':
            return <Illustration src='trial-onboarding/engagement-chatbot-bar' />;
        case 'reviewAgentsAndAvailability':
            return <Illustration src='trial-onboarding/engagement-agents' />;
        case 'setupSMS':
            return <Illustration src='trial-onboarding/engagement-sms' />;
        case 'setupFacebook':
            return <Illustration src='trial-onboarding/engagement-facebook-messenger' />;
        case 'setupInstagram':
            return <Illustration src='trial-onboarding/engagement-instagram' />;
        case 'setupWhatsApp':
            return <Illustration src='trial-onboarding/engagement-whatsapp' />;
        case 'inviteYourTeam':
        default:
            return <Illustration src='trial-onboarding/sales-invite-team' />;
    }
};

export const getCueCardsForChecklist = (checklistItems: ChecklistItem[]): any[] =>
    checklistItems.map((item) => ({
        settingsKey: item.key,
        title: item.title,
        description: item.subtitle,
        isComplete: item.isComplete,
        thumbnailPosition: 'full',
        thumbnailIllustration: getIllustration(item.key),
        thumbnailBackgroundColor: item.isComplete ? 'greenLt' : 'infoBg',
        cta: {onClick: item.onClick},
    }));
